export default {
  RISK_TOLERANCE_QUESTIONS_REPOSITORY: Symbol.for('RISK_TOLERANCE_QUESTIONS_REPOSITORY'),
  GET_RISK_TOLERANCE_QUESTIONS_QUERY: Symbol.for('GET_RISK_TOLERANCE_QUESTIONS_QUERY'),
  RISK_TOLERANCE_QUESTIONS_STATE_MANAGER: Symbol.for('RISK_TOLERANCE_QUESTIONS_STATE_MANAGER'),
};
